export default __webpack_public_path__ + "static/media/yellowgreen.bbf62a4a.png";